module.exports = __webpack_public_path__ + "static/media/pic9.d771239e.jpg";